import { createIncomingMobilityBasicInfoRoute } from './0CreateIncomingMobilityBasicInfoPage/route';
import { createIncomingMobilityRecapitulationRoute } from './1CreateIncomingMobilityRecapitulationPage/route';
import { createIncomingMobilityRoute } from './route';

export const createIncomingMobilityRoutes =
	createIncomingMobilityRoute.addChildren([
		createIncomingMobilityBasicInfoRoute,
		createIncomingMobilityRecapitulationRoute,
	]);
